import { render, staticRenderFns } from "./bigscreen.vue?vue&type=template&id=304bd4f8&scoped=true&"
import script from "./bigscreen.vue?vue&type=script&lang=js&"
export * from "./bigscreen.vue?vue&type=script&lang=js&"
import style0 from "./bigscreen.vue?vue&type=style&index=0&id=304bd4f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304bd4f8",
  null
  
)

export default component.exports